// extracted by mini-css-extract-plugin
export default {"main":"MainContainerWithSearchAndPagination_main__ftlNw"};